module.exports = __webpack_public_path__ + "img/downloadApp8.27c26f4e.svg";